'use strict';
module.exports = {
	product: {
		name: 'Cisco Webex',
		description: 'Collaborate with users in Cisco Webex meetings and spaces',
		url: 'https://www.mindmup.com/tutorials/cisco-webex.html',
		unit_label: 'users',
		metadata: {
			link: 'https://www.mindmup.com/tutorials/cisco-webex.html',
			type: 'add-in',
			quantities: '100,500'
		}
	},
	priceMetadata: {
		'add-in': 'Cisco'
	},
	prices: {
		'month': {
			'personal': [
				{'quantity': 100, 'price_in_units': 599},
				{'quantity': 500, 'price_in_units': 1199}
			]
		},
		'year': {
			'personal': [
				{'quantity': 100, 'price_in_units': 5000},
				{'quantity': 500, 'price_in_units': 10000}
			],
			'team10': [
				{'quantity': 100, 'price_in_units': 10000},
				{'quantity': 500, 'price_in_units': 20000}
			],
			'team100': [
				{'quantity': 100, 'price_in_units': 20000},
				{'quantity': 500, 'price_in_units': 40000}
			],
			'team200': [
				{'quantity': 100, 'price_in_units': 30000},
				{'quantity': 500, 'price_in_units': 60000}
			],
			'domain': [
				{'quantity': 100, 'price_in_units': 40000},
				{'quantity': 500, 'price_in_units': 80000}
			]
		}
	}

};
